export default "__VITE_ASSET__Bhky5PmT__"